const stable = value => Array.isArray(value) ? value.map(stable) : value && typeof value === 'object'
  ? Object.fromEntries(Object.keys(value).sort().map(key => [key, stable(value[key])])) : value;
const coordinate = value => value == null || value === '' ? null : Number(value);

export function orientationGcr(spacing, autoLayout, primary) {
  return Number(spacing?.gcr ?? (primary ? autoLayout?.spacingInfo?.gcr : undefined));
}

// Exclude the selected angles: the saved grid can be sliced at new angles.
export function orientationOptimizationKey(cfg, objective, gcr) {
  const po = cfg?.panelOrientation || {};
  return JSON.stringify(stable([
    1, coordinate(cfg?.loc_info?.lat ?? cfg?.lat), coordinate(cfg?.loc_info?.lon ?? cfg?.lon),
    cfg?.surfaceType, objective,
    po.transpositionModel, po.aoiModel, po.thermalModel, po.thermalSettings,
    po.installationType, po.mountingConfig, po.arrayGeometry, po.horizonProfile,
    Number.isFinite(gcr) && gcr > 0 && gcr < 1 ? gcr : null,
  ]));
}

export function restoredOrientationResult(saved, key) {
  const normalized = input => {
    try {
      const fields = JSON.parse(input);
      if (!Array.isArray(fields)) return null;
      fields[1] = coordinate(fields[1]); fields[2] = coordinate(fields[2]);
      return JSON.stringify(stable(fields));
    } catch { return null; }
  };
  return normalized(key) != null && normalized(saved?.key) === normalized(key) && Array.isArray(saved?.result?.grid) && saved.result.grid.length
    ? saved.result : null;
}
